import { RiskDataType } from "../../../modules/Utilities/ConfigureAgreement/Risk/types/RiskInterface";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/Risk/";

export const getRisk = () => {
  return axios.get(`${api_base_url}`);
};

//Add Risk
export const addRisk = async (newData) => {
  const { data } = await axios.post(`${api_base_url}`, newData);
  return data;
};

//Delete Risk
export const deleteRisk = async (ids: number[]) => {
  await axios.delete(`${api_base_url}Risk`, {
    data: ids,
  });
};

//Update Risk
export const updateRisk = async (updatedRisk: RiskDataType) => {
  const { data } = await axios.put(`${api_base_url}`, {
    ...updatedRisk,
  });
  return data;
};
